import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import Icon from "@client.components/Icon";
import "./InvitationNotificationContent.scss";

const InvitationNotificationContent = ({ user }) => {
  const { t } = useTranslation();

  return (
    <div className="invitation-notification">
      <Icon name="checkmark" isSvg={true} />
      <div className="notification">
        <div className="title">
          {t("components.UsersDataTable.invitationWasSent")}
        </div>
        <div className="user-information">
          {user.firstName} ({user.role})
        </div>
        {user.teams.length > 0 && (
          <ul className="teams-information">
            {user.teams.map((t) => (
              <li key={t.name}>{t.name}</li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

InvitationNotificationContent.propTypes = {
  user: PropTypes.shape({
    id: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    role: PropTypes.string,
    teams: PropTypes.array,
  }),
};

export default InvitationNotificationContent;
